<template>
  <div class="settings-user">
    <div class="row header-row">
      <div class="col-12 col-md-4">
        <h3>Users</h3>
      </div>
      <div class="col-12 col-md-8 text-right-md">
        <div class="search">
          <input
            id="search"
            v-model="search"
            name="search"
            type="text"
            placeholder="Search..."
          >
          <font-awesome-icon
            :icon="['fas', 'search']"
          />
        </div>

        <button
          class="btn btn-primary"
          @click="inviteUser()"
        >
          <font-awesome-icon
            :icon="['far', 'plus']"
            class="icon alt"
          />
          <span>New User</span>
        </button>
      </div>
    </div>

    <div
      v-if="loading"
      class="row"
    >
      <Loader :style="{width: '100%'}" />
    </div>

    <div
      v-else-if="items && items.length === 0"
      class="no-results"
    >
      <p v-if="!search">
        You haven't added any users yet.
      </p>

      <p v-else>
        Your search did not find anything. Please try again.
      </p>
    </div>

    <div v-else-if="items">
      <user-table :items="items" />
      
      <pagination
        v-if="count > limit"
        :filtered-count="count"
        :page="page"
        :page-size="limit"
        :on-page-changed="onPageChanged"
      />
    </div>

    <div v-if="!loading && invites && invites.length">
      <hr>

      <div class="row">
        <div class="col-12 mt-45">
          <button
            class="btn btn-primary"
            @click="viewPendingUsers()"
          >
            <font-awesome-icon
              :icon="['far', 'plus']"
              class="icon alt"
            />
            <span>View Pending Invites</span>
          </button>
        </div>
      </div>
    </div>

    <user-modal
      ref="inviteUserModal"
      :invite-type="sellingDashboardIsDefault ? 'seller' : 'buyer'"
      :on-user-invited="loadItems"
    />
    <view-pending-users-modal
      v-if="invites && invites.length"
      ref="viewPendingUsersModal"
      :invites="invites"
    />
  </div>
</template>

<script>
import UserTable from '@/components/tables/UserTable.vue';
import UserModal from '@/components/modals/UserModal.vue';
import ViewPendingUsersModal from '@/components/modals/ViewPendingUsersModal.vue';
import Pagination from '@/components/Pagination.vue';
import Loader from '@/components/Loader.vue';
import UserClient from '@/api/UserClient';

export default {
  name: 'Components',
  components: {
    UserTable,
    UserModal,
    ViewPendingUsersModal,
    Pagination,
    Loader,
  },
  data() {
    return {
      userClient: new UserClient(this.$http),
      loading: true,
      search: '',
      searchTimeout: null,

      items: null,
      count: 0,
      page: 1,
      limit: 50,

      invites: null,
    };
  },
  computed: {
    sellingDashboardIsDefault() {
      return (this.$globals.user() && this.$globals.user().user_settings.default_dashboard === 'seller') || !this.$globals.user().user_settings.buyer_dashboard;
    },
  },
  watch: {
    search() {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }

      this.searchTimeout = setTimeout(() => {
        this.loadItems();
      }, 300);
    },
  },
  mounted() {
    this.$store.commit('clearGlobalAlerts');
    this.loadItems();
  },
  methods: {
    async loadItems() {
      this.items = null;
      const offset = (this.page - 1) * this.limit;

      let usersResponse;
      let invitesResponse;
      this.loading = true;
      try {
        usersResponse = await this.userClient.getCompanyUsers(this.$globals.company().id, this.search, this.limit, offset);
        this.items = usersResponse.results;
        this.count = usersResponse.count;
      } catch (ex) {
        this.items = [];
        this.count = 0;
      }

      try {
        invitesResponse = await this.userClient.getPendingCompanyInvites(this.search, 5000);
        this.invites = invitesResponse.results;
      } catch (ex) {
        this.invites = [];
      }

      this.loading = false;
    },
    onPageChanged(page) {
      if (page !== this.page) {
        this.page = page;
        this.loadItems();
      }
    },
    inviteUser() {
      this.$refs.inviteUserModal.show();
    },

    viewPendingUsers() {
      this.$refs.viewPendingUsersModal.show();
    }
  },
};
</script>

<style lang="scss" scoped>
.settings-user {
  padding: 30px 0 75px;
  padding-left: 15px;
  padding-right: 15px;

  .header-row {
    /deep/ .btn {
      position: relative;
      top: -2px;
      width: 120px;
    }
  }
}

.text-right-md {
  @media (min-width: $md-min) {
    text-align: right;
  }
}

.search {
  position: relative;
  margin-top: 0;
  margin-right: 5px;
  max-width: 375px;
  display: inline-block;
  width: calc(100% - 150px);

  input {
    @include border-radius($border-radius);

    display: inline-block;
    width: 100%;
    max-width: 100%;
    height: 47px;
    margin-bottom: 10px;
    padding: 15px;
    border: $default-border;
    cursor: text;

    &.no-border {
      border: solid 1px white;
    }

    &:focus {
      padding: 13px;
      border: solid 3px $highlight-color;
      outline: 0;
      box-shadow: none;
    }

    &:focus,
    &.has-input {
      ~ .form__label {
        top: 10px;
        font-size: 12px;
      }
    }
  }

  i,
  svg {
    position: absolute;
    right: 15px;
    top: 15px;
    opacity: 0.75;
  }
}
</style>
